var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningSignBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 4.99161L16.2749 15.8333H3.72494L9.99994 4.99161ZM2.28327 14.9999C1.6416 16.1083 2.4416 17.4999 3.72494 17.4999H16.2749C17.5583 17.4999 18.3583 16.1083 17.7166 14.9999L11.4416 4.15828C10.7999 3.04994 9.19994 3.04994 8.55827 4.15828L2.28327 14.9999ZM9.1666 9.16661V10.8333C9.1666 11.2916 9.5416 11.6666 9.99994 11.6666C10.4583 11.6666 10.8333 11.2916 10.8333 10.8333V9.16661C10.8333 8.70828 10.4583 8.33328 9.99994 8.33328C9.5416 8.33328 9.1666 8.70828 9.1666 9.16661ZM9.1666 13.3333H10.8333V14.9999H9.1666V13.3333Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningSignBlue);
export default __webpack_public_path__ + "static/media/IconWarningSignBlue.3d8e7287ee27704d8c729bac3c71c3fb.svg";
export { ForwardRef as ReactComponent };